import { render, staticRenderFns } from "./ContasPagarForm.vue?vue&type=template&id=40a497fc&scoped=true&"
import script from "./ContasPagarForm.vue?vue&type=script&setup=true&lang=js&"
export * from "./ContasPagarForm.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a497fc",
  null
  
)

export default component.exports